module.exports = __webpack_public_path__ + "static/media/022.294f20f8.jpg";